
export const mode = import.meta.env.MODE
export const isDevelopment = mode === 'development'
export const isStaging = mode === 'staging'
export const isProduction = mode === 'production'

export const restBaseUrl = getRestBaseUrl()

function getRestBaseUrl() {
	if (isDevelopment) {
		return ""
	}
	if (isStaging) {
		return "https://rest.staging.hangaround.live"
	}
	return "https://rest.hangaround.live"
}

export const socketUrl = getSocketUrl()

function getSocketUrl() {
	if (isDevelopment) {
		// In dev, socket.io is proxied through Vite (see vite.config.ts) so the
		// browser stays on the same origin and the auth cookie is sent correctly.
		return ""
	}
	if (isStaging) {
		return "https://socket.staging.hangaround.live"
	}
	return "https://socket.hangaround.live"
}
